import { useConnect, useDisconnect } from "wagmi";
import useWeb3ErrorToast from "../utils/useWeb3ErrorToast";

const useAuth = () => {
  const { connect, connectors } = useConnect();
  const { disconnect } = useDisconnect();
  const { handleError } = useWeb3ErrorToast();

  const login = async (connectorID) => {
    try {
      let target;
      if (connectorID === "injected") {
        target = connectors.find(
          (c) =>
            c.id === "injected" ||
            c.name?.toLowerCase().includes("metamask")
        );
      } else if (connectorID === "walletconnect") {
        target = connectors.find((c) => c.id === "walletConnect");
      }
      if (target) {
        connect({ connector: target });
      }
    } catch (error) {
      console.error("Login error:", error);
      handleError(error);
    }
  };

  const logout = async () => {
    try {
      disconnect();
    } catch (error) {
      console.error("Logout error:", error);
      handleError(error);
    }
  };

  return { login, logout };
};

export default useAuth;
